import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostToBackoffice } from "../../utils/commands";

type CommandResponse = { message?: string };

export type ChangeMotherBoardArg = {
  serialNumber: string;
  /** Used to know when the read model has a new value so we can drop the empty display override. */
  deviceIdBeforeChange: string;
  reason: string;
};

export const changeMotherBoard = createAsyncThunk(
  "deviceIdOverride/changeMotherBoard",
  async (arg: ChangeMotherBoardArg, { rejectWithValue }) => {
    const res = (await PostToBackoffice("cmd/machine/changeMotherBoard", {
      serialNumber: arg.serialNumber,
      reason: arg.reason,
    })) as CommandResponse;

    if (res.message && res.message.includes("failed")) {
      return rejectWithValue(res.message);
    }

    return { serialNumber: arg.serialNumber };
  },
);
